/**
 * WordPress dependencies
 */

import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import React from 'react';

const Edit = (props) => {
  const {
    attributes: { align },
  } = props;

  const blockProps = useBlockProps({
    className: 'cards-group align' + align,
  });

  return (
    <div {...blockProps}>
      <div className="cards-group__inner container">
        <InnerBlocks
          allowedBlocks={['acf/card-item']}
          template={[['acf/card-item']]}
        />
      </div>
    </div>
  );
};
export default Edit;
